import { TableCard } from '../../../../components'
import { NotaAtendimentosListHeader } from './components/header/NotaAtendimentosListHeader'
import { NotaAtendimentosListInfo } from './components/header/NotaAtendimentosListInfo'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { NotaAtendimentosTable } from './table/NotaAtendimentosTable'

const NotaAtendimentosList = () => {
  return (
    <>
      <NotaAtendimentosListInfo />
      <TableCard>
        <NotaAtendimentosListHeader />
        <NotaAtendimentosTable />
      </TableCard>
    </>
  )
}

export const NotaAtendimentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <NotaAtendimentosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
